export default __webpack_public_path__ + "static/media/smear-test.37431957.svg";